export const state = {
    totalLoadedImages: 0,
    isLoading: false,
    currentCategory: "all",
    currentCategoryIds: [],
    usedIds: {}
};
